module.exports = __webpack_public_path__ + "img/美型后.6f610401.jpg";